import { CSSProperties, useMemo } from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'
import { ServiceLocationsProps } from '../typings'
import { locationListStyles } from './useLocationListStyles'

export function useServiceLocationStyles(params: ServiceLocationsProps) {
  const { variant } = params

  const screenWideEnough = useMediaQuery('(min-width:1060px)')

  const styles = useMemo(() => {
    const popover = variant === 'card'

    return {
      columns: {
        maxHeight: popover ? '423px' : 'unset',
        flexDirection: popover && !screenWideEnough ? 'column' : 'row',
        flexWrap: popover ? 'nowrap' : 'wrap',
      } as CSSProperties,
    }
  }, [screenWideEnough, variant])
  const listViewStyles = useMemo(() => {
    const popover = variant === 'card'

    return {
      columns: {
        maxHeight: popover ? '423px' : 'unset',
        flexDirection: 'column',
        paddingTop: '10px',
        flexWrap: popover ? 'nowrap' : 'wrap',
      } as CSSProperties,
    }
  }, [variant])
  return [locationListStyles, styles, listViewStyles] as const
}
